import React from 'react';
import { StyleSheet, Pressable, View } from 'react-native';
import { Box, Iffy, Modal, Text, luxColors, Icon, DNAButton } from '../../../index';
const styles = StyleSheet.create({
    backdrop: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    bodyText: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: 14,
        lineHeight: 24,
        marginTop: 10,
    },
    buttonContainer: {
        flexDirection: 'row',
        alignSelf: 'flex-end',
        marginTop: 24,
        marginBottom: 12,
        marginLeft: 24,
        marginRight: 24,
    },
    container: {
        backgroundColor: luxColors.confirmationBackground.primary,
        borderColor: luxColors.menuBorder.primary,
        borderRadius: 3,
        borderWidth: 1.5,
        flex: 1,
        minHeight: 164,
        shadowColor: luxColors.menuShadown.primary,
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        width: 420,
    },
    descriptionContainer: {
        marginTop: 24,
        marginBottom: 24,
        marginLeft: 24,
        marginRight: 24,
    },
    header: {
        alignSelf: 'flex-start',
        color: luxColors.confirmationHeader.primary,
        fontSize: 18,
        fontWeight: 'bold',
        lineHeight: 24,
        marginLeft: 24,
        marginRight: 24,
        marginTop: 12,
        marginBottom: 12,
    },
    headerCloseButton: {
        flexDirection: 'column',
        alignSelf: 'center',
        marginRight: 17,
    },
    headerContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    icon: {
        color: luxColors.closeIcon.primary,
        height: 24,
        width: 24,
    },
    textContainer: {
        color: luxColors.confirmationText.primary,
    },
});
function Confirmation(props) {
    const { onCancel, onSuccess, body, showCloseButton, header, text, successText, cancelText = 'Cancel' } = props;
    return (<Modal visible={true} backdropStyle={styles.backdrop}>
      <Box>
        <Box style={styles.container}>
          <Box style={styles.headerContainer}>
            <Box>
              <Text style={styles.header}>{header}</Text>
            </Box>
            <Iffy is={showCloseButton}>
              <Pressable onPress={onCancel}>
                <View style={styles.headerCloseButton}>
                  <Icon style={styles.icon} name="close"/>
                </View>
              </Pressable>
            </Iffy>
          </Box>
          <Box style={styles.descriptionContainer}>
            <Text style={styles.textContainer}>
              {text}
            </Text>
            <Iffy is={body}>
              <Text style={styles.bodyText}>
                {body}
              </Text>
            </Iffy>
          </Box>
          <Box style={styles.buttonContainer}>
            <DNAButton size="xs" appearance="ghost" status="dark" onPress={onCancel}>
              {cancelText}
            </DNAButton>
            <DNAButton size="xs" status="primary" style={[{ marginLeft: 5 }]} onPress={onSuccess}>
              {successText}
            </DNAButton>
          </Box>
        </Box>
      </Box>
    </Modal>);
}
export default React.memo(Confirmation);
//# sourceMappingURL=Confirmation.js.map